import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fbea09f0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbea09f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbea09f0')) {
      api.createRecord('fbea09f0', component.options)
    } else {
      api.reload('fbea09f0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fbea09f0&scoped=true", function () {
      api.rerender('fbea09f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/application/routine/linkGenerator/index.vue"
export default component.exports